import SessionTimedOutForm from "../../components/views/session-timeout/session-timed-out-form";

function SessionTimedOutPage() {

  return <SessionTimedOutForm />
}

export default SessionTimedOutPage;
